import * as d3 from "d3";
import { isValidNumber } from "utils/validation";
import { fixRoundingErrors } from "utils/math";
export var initGraph = function initGraph(ref, margin) {
  var svg = d3.select(ref);
  var chartData = svg.append("g").attr("class", "chartData").attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")"));
  chartData.append("g").attr("class", "layers");
  svg.append("g").attr("class", "tooltip").style("display", "none").style("pointer-events", "none");
};
export var updateTooltip = function updateTooltip(_ref) {
  var svg = _ref.svg;
  var tooltip = svg.select(".tooltip");
  tooltip.append("rect").attr("fill", "white");
  tooltip.append("text").attr("dy", 23).style("text-anchor", "middle").style("font-size", "1.4rem").style("font-family", "Roboto-bold").style("font-weight", "normal");
};
export var updateValues = function updateValues(_ref2) {
  var data = _ref2.data,
    svg = _ref2.svg,
    content = _ref2.content,
    x = _ref2.x,
    y = _ref2.y,
    z = _ref2.z,
    height = _ref2.height,
    measureUnit = _ref2.measureUnit;
  var layersSelection = content.selectAll(".layers").selectAll(".layer").data(data);
  var layer = layersSelection.enter().append("g").attr("class", "layer");
  var layers = layersSelection.merge(layer);
  layersSelection.exit().remove();
  var partitionSelection = layers.selectAll("rect").data(function (d) {
    return d;
  }, function (d) {
    return d.data.id;
  });
  var partition = partitionSelection.enter().append("rect").attr("y", function (d) {
    return y(d.data.id);
  }).attr("x", 0).style("stroke", "white").style("fill", function (d) {
    return z(d.key);
  }).on("mouseover", function () {
    svg.select(".tooltip").style("display", null);
  }).on("mouseout", function () {
    svg.select(".tooltip").style("display", "none");
  }).on("mousemove", function (d) {
    var value = fixRoundingErrors(d, d[1] - d[0]);
    var label = "".concat(d.key, ": ").concat(value, " ").concat(measureUnit === "%" ? measureUnit : "");
    var tooltip = svg.select(".tooltip");
    tooltip.select("rect").attr("height", 38).attr("stroke", z(d.key)).attr("stroke-width", "3px").attr("width", label.length * 11);
    tooltip.select("text").attr("id", label).text(label);
    var textWidth = document.getElementById(label).getComputedTextLength();
    var xPosition = d3.mouse(this)[0] - textWidth / 2;
    var yPosition = d3.mouse(this)[1] - 20;
    var maxY = height;
    var minY = 0;
    yPosition = yPosition < minY ? minY : yPosition > maxY ? maxY : yPosition;
    var maxX = x(x.domain()[1]) - textWidth;
    var minX = x(x.domain()[0]);
    xPosition = xPosition > maxX ? maxX : xPosition < minX ? minX : xPosition; //if xPos is too far to the right

    tooltip.select("rect").attr("width", textWidth + 30);
    tooltip.select("text").attr("x", (textWidth + 30) / 2);
    tooltip.attr("transform", "translate(".concat(xPosition, ", ").concat(yPosition, ")"));
  });
  partitionSelection.merge(partition).transition().duration(400).attr("x", function (d) {
    return x(d[0]);
  }).attr("y", function (d) {
    return y(d.data.id);
  }).style("fill", function (d) {
    return z(d.key);
  }).style("stroke", "white").attr("width", function (d) {
    var value = x(d[1] - d[0]);
    return isValidNumber(value) ? fixRoundingErrors(d, value) : null;
  }).attr("height", y.bandwidth());
  partitionSelection.exit().remove();
};